
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import VouchersGenerateRandom from './VouchersGenerateRandom';

const GenerateRandomVouchersMutation = gql`
  mutation generateRandomVouchers($data: GenerateRandomVouchersInput!) {
    generateRandomVouchers(data: $data) {
      id
    }
  }
`;

export default compose(
  graphql<any, GQL.IQuery>(GenerateRandomVouchersMutation, {
    name: 'generateRandomVouchers'
  }),
)(VouchersGenerateRandom);



// WEBPACK FOOTER //
// ./src/scenes/VouchersGenerateRandom/index.tsx